import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, input, output, ViewChild } from '@angular/core';

@Component({
  selector: 'app-hexagon-border-svg',
  standalone: true,
  template: `
    <svg width="196" height="226" viewBox="0 0 196 226" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="paint0_linear_hex_border" x1="97.8906" y1="224.456" x2="97.8906" y2="0.690662"
                        gradientUnits="userSpaceOnUse">
          <stop offset="0" [attr.stop-color]="color()"/>
          <stop offset="1" [attr.stop-color]="color()"/>
        </linearGradient>
        <mask id="borderRevealMask_hex">
          <rect x="0" y="0" width="196" height="226" fill="black"/>
          <path
            #borderPath
            d="M97.8906 1.26796
               C98.2718 0.91068 98.8906 0.91068 99.5 1.26796
               L193.781 56.0547
               C194.4 56.412 194.781 57.0722 194.781 57.7867
               L194.781 167.36
               C194.781 168.075 194.4 168.735 193.781 169.092
               L98.8906 223.879
               C98.2718 224.236 97.5094 224.236 96.8906 223.879
               L2 169.092
               C1.38121 168.735 1.00003 168.075 1.00003 167.36
               L1.00003 57.7867
               C1.00003 57.0722 1.38121 56.412 2 56.0547
               L96.8906 1.26796
               C97.5094 0.91068 97.8906 0.91068 97.8906 1.26796
               Z"
            stroke="white"
            stroke-width="6"
            fill="none"
            [attr.stroke-dasharray]="dashArray()"
            [attr.stroke-dashoffset]="dashOffset()"/>
        </mask>
      </defs>
      <path
        d="M97.8906 1.26796
           C98.2718 0.91068 98.8906 0.91068 99.5 1.26796
           L193.781 56.0547
           C194.4 56.412 194.781 57.0722 194.781 57.7867
           L194.781 167.36
           C194.781 168.075 194.4 168.735 193.781 169.092
           L98.8906 223.879
           C98.2718 224.236 97.5094 224.236 96.8906 223.879
           L2 169.092
           C1.38121 168.735 1.00003 168.075 1.00003 167.36
           L1.00003 57.7867
           C1.00003 57.0722 1.38121 56.412 2 56.0547
           L96.8906 1.26796
           C97.5094 0.91068 97.8906 0.91068 97.8906 1.26796
           Z"
        stroke="url(#paint0_linear_hex_border)"
        stroke-width="2"
        fill="none"
        stroke-dasharray="17.9 4.48"
        mask="url(#borderRevealMask_hex)"/>
    </svg>
  `,
  styles: [`
    :host {
      display: block;
    }
    svg {
      display: block;
      width: 100%;
      height: 100%;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HexagonBorderSvgComponent implements AfterViewInit {
  @ViewChild('borderPath') borderPath!: ElementRef<SVGPathElement>;

  readonly color = input.required<string>();
  readonly dashArray = input.required<string>();
  readonly dashOffset = input.required<number>();

  readonly pathLengthCalculated = output<number>();

  ngAfterViewInit(): void {
    if (this.borderPath?.nativeElement) {
      const length = this.borderPath.nativeElement.getTotalLength();
      if (length > 0) {
        this.pathLengthCalculated.emit(length);
      }
    }
  }
}
